import React, { useEffect, useState } from "react";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Badge, Tooltip } from "@mui/material";
import { useMutation } from "react-query";
import { GetCartSummary } from "../../service/store.service";
import { useHistory, withRouter } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { setCartCount } from "../../redux/cartSummary/cartCountAction";
import { count } from "console";
function CartSummary({ summatyCount }: summaryCountPropsInterface) {
  // const [count, setCount] = useState(0);
  const history = useHistory();
  const cartSummaryMutate = useMutation(GetCartSummary, {
    onSuccess: (data) => {
      dispatch(setCartCount({ count: data.data }));
    },
  });
  const dispatch = useDispatch();
  const MINUTE_MS = 15 * 60 * 1000;

  useEffect(() => {
    const interval = setInterval(() => {
      // cartSummaryMutate.mutate();
    }, MINUTE_MS);

    // cartSummaryMutate.mutate();
    return () => clearInterval(interval);
  }, []);

  const handleGoCart = () => {
    history.push("/products/cart");
    // cartSummaryMutate.mutate();
  };
  const jsonFile = useSelector((state: any) => state.style);

  return (
    <div
      className="borderLeft-TopBarIcon px-2 cartSummary"
      onClick={handleGoCart}
    >
      <Tooltip title="سبد خرید" arrow>
        <Badge
          color={jsonFile?.badgeColor}
          sx={{
            "&.MuiBadge-badge": {
              fontWeight: "bold",
              fontSize: "14px !important",
              direction: "ltr",
            },
          }}
          badgeContent={summatyCount.count}
        >
          <ShoppingCartOutlinedIcon
            className="Icons BorderColor cursorPointer "
            style={{ width: "30px" }}
          />
        </Badge>
      </Tooltip>
    </div>
  );
}
interface summaryCountPropsInterface {
  summatyCount: any;
}
const mapStateToProps = ({ summatyCount }: summaryCountPropsInterface) => {
  return { summatyCount };
};

export default withRouter(connect(mapStateToProps)(CartSummary));
